import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  dustMonitorClasses: "DustMonitorClass.DustMonitorClasses",
  list: "DustMonitorClass.DustMonitorClassList",
  base: "DustMonitorClass.DustMonitorClassBase",
  view: "DustMonitorClass.DustMonitorClassView",
  documents: "DustMonitorClass.DustMonitorClassDocuments",
  documentsEdit: "DustMonitorClass.DustMonitorClassDocumentsEdit",
  documentsNew: "DustMonitorClass.DustMonitorClassDocumentsNew",
  notes: "DustMonitorClass.DustMonitorClassNotes",
  noteEdit: "DustMonitorClass.DustMonitorClassNoteEdit",
  noteNew: "DustMonitorClass.DustMonitorClassNoteNew",
  // audit: "DustMonitorClass.DustMonitorClassAudit",
};

export { names as dustMonitorClassRouteNames };

const dustMonitorRoutes: RouterOptions["routes"] = [
  {
    path: "/dustMonitorClass",
    name: names.dustMonitorClasses,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Dust Monitor Classes",
          lookupGroups: [],
        },
        component: () => import("@/views/dustMonitorClass/DustMonitorClassList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/dustMonitorClass/DustMonitorClassBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Dust Monitor Class View" },
            component: () => import("@/views/dustMonitorClass/DustMonitorClassView.vue"),
          },

          {
            path: "documents",
            name: names.documents,
            meta: { title: "Dust Monitor Class Documents" },
            component: {
              render: () => <EntityDocumentsChildList resourceTypeKey="dustMonitorClass" />,
            },
          },
          {
            path: "documents/:documentId(\\d+)",
            name: names.documentsEdit,
            meta: { title: "Edit Dust Monitor Class Document", isForm: true },
            component: {
              render: () => <EntityDocumentForm resourceTypeKey="dustMonitorClass" />,
            },
          },
          {
            path: "documents/new",
            name: names.documentsNew,
            meta: { title: "Create Dust Monitor Class Documents", isForm: true },
            component: {
              render: () => <EntityDocumentMultipleForm resourceTypeKey="dustMonitorClass" />,
            },
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Dust Monitor Class Notes" },
            component: {
              render: () => (
                <EntityNotes idField="dustMonitorClassId" routeNamePrefix="DustMonitorClass.DustMonitorClassNote" />
              ),
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Dust Monitor Class Note", isForm: true },
            component: () => import("@/views/dustMonitorClass/DustMonitorClassNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Dust Monitor Class Note", isForm: true },
            component: () => import("@/views/dustMonitorClass/DustMonitorClassNote.vue"),
          },
          // {
          //   path: "activity",
          //   name: names.audit,
          //   meta: { title: "Dust Monitor Class Audit Activity" },
          //   component: {
          //     render: () => <EntityAudit entityType="DustMonitorClass" />,
          //   },
          // },
        ],
      },
    ],
  },
];
export default dustMonitorRoutes;
